





































































































































































































































































































import { Component, Vue, Mixins } from 'vue-property-decorator';

// Services
import Staff from '@/services/Staff';
import * as Sentry from '@sentry/browser';
import Claims from '@/services/Claims';

// Mixins
import UpdateClaimMixin from '@/mixins/Staff/Claims/UpdateClaim';

// Components
import Alert from '@/components/Global/Alert.vue';
import Loading from '@/components/Global/Loading.vue';
import TextField from '@/components/Form/TextField.vue';
import SelectField from '@/components/Form/SelectField.vue';
import SwitchField from '@/components/Form/SwitchField.vue';
import TextArea from '@/components/Form/TextArea.vue';

// Validations
import { email, maxLength } from 'vuelidate/lib/validators';

@Component({
	name: 'PageStaffClaimsSingle',
	components: {
		Alert,
		Loading,
		SelectField,
		TextField,
		TextArea,
		SwitchField,
	},
	validations: {
		comments: {
			maxLength: maxLength(256),
		},
	},
})
export default class ClaimsSingle extends Mixins(UpdateClaimMixin) {
	public claimId: string;
	public claimStatus: string;
	public assignee: string;
	public realClaimId: string;
	public claim: any;
	public loading: boolean;
	public error: boolean;
	public errorSave: boolean;
	public comments: string;
	public setup: boolean;

	constructor() {
		super();

		this.claimId = '';
		this.claimStatus = '';
		this.assignee = '';
		this.realClaimId = '';
		this.claim = {};
		this.loading = true;
		this.error = false;
		this.errorSave = false;
		this.comments = '';
		this.setup = false;
	}

	private async created() {
		// this.claimId = this.$route.params.id;

		try {
			const getClaim = await Staff.getClaim(this.claimId);

			if ('claim_data' in getClaim.data) {
				this.claim = getClaim.data;
				if ('comments' in this.claim) {
					this.comments = this.claim.comments;
				}

				if ('setup' in this.claim) {
					this.setup = this.claim.setup;
				}

				Object.keys(this.claim).map(o => {
					if (this.claim.hasOwnProperty('assignee')) {
						this.assignee = this.claim.assignee;
					}

					if (this.claim.hasOwnProperty('real_claim_id')) {
						this.realClaimId = this.claim.real_claim_id;
					}

					return this.claim[o];
				});

				this.claimStatus = Claims.getClaimStatus(this.claim);
			}
		} catch (e) {
			Sentry.captureException(e);
			this.error = true;
		} finally {
			this.loading = false;
		}
	}
}
